export const MUTUAL_SETTLEMENTS_TABLE_KEY = 'MUTUAL_SETTLEMENTS_TABLE_KEY';
